import { DetailedHTMLProps, FC, HTMLAttributes } from 'react'
import classNames from 'classnames'

interface Props extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  className?: string
}
export const FlexRow: FC<Props> = ({ className, children, ...props }) => {
  return (
    <div className={classNames('flex items-center', className)} {...props}>
      {children}
    </div>
  )
}
